import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { TeamComponent } from './components/team/team.component';
import { GameSetUpService } from './providers/gameSetUp.service';
import { ReversePipe } from './pipes/reverse.pipe';
import { PadComponent } from './components/pad/pad.component';
import { FinishListService } from './providers/finishList.service';
import { SetUpComponent } from './components/set-up/set-up.component';
import { GameComponent } from './components/game/game.component';
import { WinnerComponent } from './components/winner/winner.component';
import { OrderComponent } from './components/order/order.component';
import { LastGamesService } from './providers/lastGames.service';
import { LastGamesComponent } from './components/last-games/last-games.component';
import { RangeSliderComponent } from './components/range-slider/range-slider.component';
import { ScaleComponent } from './components/scaling/scaling.component';
import { SwitchComponent } from './components/switch/switch.component';
import { GamePadComponent } from './components/game-pad/game-pad.component';
import { ButtonComponent } from './components/button/button.component';
import { PortraitBlockComponent } from './components/portrait-block/portrait-block.component';





@NgModule({
  declarations: [
    AppComponent,
    TeamComponent,
    PadComponent,
    SetUpComponent,
    GameComponent,
    WinnerComponent,
    OrderComponent,
    LastGamesComponent,
    RangeSliderComponent,
    ScaleComponent,
    SwitchComponent,
    GamePadComponent,
    ButtonComponent,
    PortraitBlockComponent,
    ReversePipe,
  ],
  imports: [
    BrowserModule,
    FormsModule
  ],
  providers: [
    GameSetUpService,
    FinishListService,
    LastGamesService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts